import BaseComponent from "../../baseComponent.js";
import UniqueIdGenerator from "../../../core/utils/uniqueIdGenerator.js";
import styles from "./check-box.scss";

export default class CheckBox extends BaseComponent {
  constructor(props) {
    super(props);
    this.itemId = UniqueIdGenerator.id();
  }

  componentWillUnmount() {
    document.getElementById(this.itemId).checked = false;
    this.itemId = null;
  }

  componentDidUpdate() {
    document.getElementById(this.itemId).checked = this.props.value;
  }

  handleChange() {
    if (document.getElementById(this.itemId).checked == false) {
      document.getElementById(this.itemId).checked = true;
    } else if (document.getElementById(this.itemId).checked == true) {
      document.getElementById(this.itemId).checked = false;
    }
    this.props.onChange(document.getElementById(this.itemId).checked);
  }

  render() {
    return (
      <div className={styles.container} onClick={e => this.handleChange(e)}>
        <input type="checkbox" className={["filled-in", styles.center].join(" ")} defaultChecked={this.props.value}
               id={this.itemId}/>
        <label className="vertical-center-align" htmlFor={this.itemId}>{this.props.text}</label>
      </div>
    )
  }
}







// WEBPACK FOOTER //
// ./src/components/common/check-box/checkBox.jsx